exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{margin:0 auto 60px;max-width:800px;min-height:101vh}@media screen and (max-width:800px){#app{margin:0 40px 60px}}#app img{display:block;max-width:100%;height:auto}#app p{text-align:left}#app main section{margin:30px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a7f28c8","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 515
// module chunks = 0